import { useEffect } from 'react';
import type { TextObject } from '../utils/selection-style';

/**
 /**
  * Runs read whenever the text selection or editing state changes.
  * This only mirrors Fabric state, so it should not create undo history.
  */
export const useOnSelectionChange = (textObject: TextObject | null, read: () => void): void => {
  useEffect(() => {
    read();
    if (!textObject) return;
    textObject.on('selection:changed', read);
    textObject.on('editing:entered', read);
    textObject.on('editing:exited', read);
    return () => {
      textObject.off('selection:changed', read);
      textObject.off('editing:entered', read);
      textObject.off('editing:exited', read);
    };
  }, [textObject, read]);
};
